import request from "@/global/request/request";
import API from "@/global/request/api";

const projectService = {
  list(params = {}) {
    return request.get(API.project, params);
  },
  item(id) {
    return request.get(API.projectItem(id));
  },
  create(params = {}) {
    return request.post(API.project, params);
  },
  update(id, params = {}) {
    return request.put(API.projectItem(id), params);
  },
  task(params = {}) {
    return request.get(API.projectTask, params);
  },
  taskItem(id) {
    return request.get(API.projectTaskItem(id));
  },
  searchCodingFileList(params = {}) {
    return request.get(API.codingFileSearch, params);
  },
  getCodingFileDetail(id) {
    return request.get(API.codingFileDetail(id));
  },
  questionTest(params) {
    return request.post(API.questionTest, params);
  }
};

export default projectService;
